// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commutably {
  --strong-font-size: 1.2em;
  --strong-font-weight: bold;
  --strong-font-style: italic;
  --strong-font-variant: small-caps;
  --strong-font-family: var(--logo-font);
  --strong-text-decoration: underline;
  --strong-text-underline-offset: 0.1em;
  --strong-color: var(--color-blue-1);
}
`, "",{"version":3,"sources":["webpack://./src/theme/components/Strong.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,sCAAsC;EACtC,mCAAmC;EACnC,qCAAqC;EACrC,mCAAmC;AACrC","sourcesContent":[".commutably {\n  --strong-font-size: 1.2em;\n  --strong-font-weight: bold;\n  --strong-font-style: italic;\n  --strong-font-variant: small-caps;\n  --strong-font-family: var(--logo-font);\n  --strong-text-decoration: underline;\n  --strong-text-underline-offset: 0.1em;\n  --strong-color: var(--color-blue-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
